import { isLocalUrl } from '../utils';

export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'seo-concept3-container';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
      } else {
        createCustomSeo(data.items[0]);
        $(`.${wrapContainerClass}`).addClass('is-loaded');
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description, URL } = widgetData;
    const $seo = $widget.find('.card-widget-item');

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <p class="seo-description">${Description}</p>
      <a href="${URL}" class="button"  ${isLocalUrl(URL) ? '' : "target='_blank'"}>Learn More</a>
    `);
  }
}
